<div class="login-page" authTheme>
  <div class="login-container">
    <!-- Logo and Header -->
    <div class="text-center mb-4">
      <img [src]="logo" alt="ADN Logo" class="login-logo" />
    </div>

    <!-- Loading State -->
    <div *ngIf="loadingInvitation" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3 text-muted">Loading invitation details...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="!loadingInvitation && invitationError">
      <div class="alert alert-danger" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ invitationError }}
      </div>
      <a routerLink="/login" class="btn btn-primary w-100">Go to Login</a>
    </div>

    <!-- Invitation Content -->
    <div *ngIf="!loadingInvitation && !invitationError && invitationDetails">

      <!-- Success Message -->
      <div *ngIf="successMessage" class="alert alert-success" role="alert">
        <i class="bi bi-check-circle-fill me-2"></i>
        {{ successMessage }}
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ errorMessage }}
      </div>

      <!-- FLOW: login_required - User already has Firebase account -->
      <div *ngIf="flowType === 'login_required'">
        <h2 class="h3 mb-2 text-center">Sign In to Accept</h2>
        <p class="text-muted text-center mb-4">
          <ng-container *ngIf="invitationDetails.profile?.firstName || invitationDetails.profile?.lastName">Hello {{ invitationDetails.profile?.firstName }} {{ invitationDetails.profile?.lastName }},<br /></ng-container>
          <ng-container *ngIf="invitationDetails.organization?.name; else noOrgName">You've been invited to join <strong>{{ invitationDetails.organization?.name }}</strong> as a <strong>{{ getRoleDisplayName(invitationDetails.invitation.role) }}</strong>.</ng-container>
          <ng-template #noOrgName>You've been invited to join as a <strong>{{ getRoleDisplayName(invitationDetails.invitation.role) }}</strong>.</ng-template>
        </p>

        <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
          <!-- Email (Read-only) -->
          <div class="mb-3">
            <label class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              [value]="invitationDetails.invitation.email"
              readonly
              disabled
            >
          </div>

          <!-- Password -->
          <app-form-password
            formControlName="password"
            label="Password"
            placeholder="Enter your password"
            [showRequirements]="false"
          ></app-form-password>

          <!-- Submit Button -->
          <app-form-button
            type="submit"
            [label]="loading ? 'Signing In...' : 'Sign In & Accept Invitation'"
            variant="primary"
            [fullWidth]="true"
            [loading]="loading"
            [disabled]="loginForm.invalid || loading"
          ></app-form-button>
        </form>

        <!-- Forgot Password Link -->
        <div class="text-end mb-3 mt-3">
          <a routerLink="/forgot-password" class="text-decoration-none">
            Forgot password?
          </a>
        </div>
      </div>

      <!-- FLOW: password_setup or account_creation - User needs to set up password -->
      <div *ngIf="flowType === 'password_setup' || flowType === 'account_creation'">
        <h2 class="h3 mb-2 text-center">
          {{ flowType === 'password_setup' ? 'Complete Your Account' : 'Create Your Account' }}
        </h2>
        <p class="text-muted text-center mb-4">
          <ng-container *ngIf="invitationDetails.organization?.name; else noOrgName">You've been invited to join <strong>{{ invitationDetails.organization?.name }}</strong> as a <strong>{{ getRoleDisplayName(invitationDetails.invitation.role) }}</strong>.</ng-container>
          <ng-template #noOrgName>You've been invited to join as a <strong>{{ getRoleDisplayName(invitationDetails.invitation.role) }}</strong>.</ng-template>
        </p>

        <form [formGroup]="passwordForm" (ngSubmit)="onPasswordSubmit()">
          <!-- First / Last Name (pre-filled from invitation, editable), side by side -->
          <div class="row g-3 mb-3">
            <div class="col-6">
              <label class="form-label" for="firstName">First Name</label>
              <input
                id="firstName"
                type="text"
                class="form-control"
                formControlName="firstName"
                maxlength="100"
                autocomplete="given-name"
              >
            </div>
            <div class="col-6">
              <label class="form-label" for="lastName">Last Name</label>
              <input
                id="lastName"
                type="text"
                class="form-control"
                formControlName="lastName"
                maxlength="100"
                autocomplete="family-name"
              >
            </div>
          </div>

          <!-- Email (Read-only) -->
          <div class="mb-3">
            <label class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              [value]="invitationDetails.invitation.email"
              readonly
              disabled
            >
          </div>

          <!-- Password -->
          <app-form-password
            formControlName="password"
            label="Password"
            placeholder="Enter password (min. 8 characters)"
            [showRequirements]="true"
          ></app-form-password>

          <!-- Confirm Password -->
          <app-form-password
            formControlName="confirmPassword"
            label="Confirm Password"
            placeholder="Re-enter password"
            [showRequirements]="false"
          ></app-form-password>

          <!-- Password Mismatch Error -->
          <div *ngIf="passwordMismatch" class="alert alert-danger small mt-2" role="alert">
            Passwords do not match
          </div>

          <!-- Submit Button -->
          <app-form-button
            type="submit"
            [label]="loading
              ? (flowType === 'password_setup' ? 'Setting Up...' : 'Creating Account...')
              : (flowType === 'password_setup' ? 'Complete Setup' : 'Create Account')"
            variant="primary"
            [fullWidth]="true"
            [loading]="loading"
            [disabled]="passwordForm.invalid || loading"
          ></app-form-button>
        </form>

        <div class="text-center mt-4">
          <p class="text-muted">
            Already have an account? <a routerLink="/login" class="text-decoration-none fw-medium">Sign In</a>
          </p>
        </div>
      </div>

    </div>
  </div>
</div>
